import declareParam from './view/declareParam.html'

export default {
  base: {
    state: 'declaration.vatDeclarationSurcharges.declareParam',
    config: {
      url: '/declareParam',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.vatDeclarationSurcharges.declareParam.list',
      title: '纳税申报配置',
    },
  },
  list: {
    state: 'declaration.vatDeclarationSurcharges.declareParam.list',
    config: {
      url: '/list',
      template: declareParam,
      controller: 'declareParamCtrl',
    },
  },
  edit: {
    state: 'declaration.vatDeclarationSurcharges.declareParam.edit',
    config: {
      url: '/edit/:id',
      template: require('./view/declareParamEdit.html'),
      controller: 'declareParamEditCtrl',
      title: '编辑',
    },
  },
  add: {
    state: 'declaration.vatDeclarationSurcharges.declareParam.add',
    config: {
      url: '/add',
      template: require('./view/declareParamEdit.html'),
      controller: 'declareParamEditCtrl',
      title: '新增',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declareParam/routers.js